import { render, staticRenderFns } from "./SecondStep-ca.vue?vue&type=template&id=1b7d1fdd"
import script from "./SecondStep-ca.vue?vue&type=script&lang=ts"
export * from "./SecondStep-ca.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports